import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import TelegramChatsList from "./TelegramChatsList";

const TelegramChatsContainer = () => {
  const { t } = useTranslation("telegramBotPage");

  const [chats, setChats] = useState(null);
  const [notification, setNotification] = useState({ visible: false, type: "", message: "" });

  const fetchChats = () => {
    axios.get("/api/telegram/chats", userAuthenticationConfig()).then(response => {
      if (response.status === 200) setChats(response.data["hydra:member"]);
    }).catch(error => {
      setNotification({
        visible: true,
        type: "error",
        message: error?.response?.data?.message || t("chats.errors.load")
      });
    });
  };

  useEffect(() => {
    fetchChats();
  }, []);

  const handleToggled = (updatedChat) => {
    setChats(prev => prev.map(chat => chat.id === updatedChat.id ? updatedChat : chat));
  };

  return (
    <>
      <Notification notification={notification} setNotification={setNotification} />
      <TelegramChatsList chats={chats} onToggled={handleToggled} setNotification={setNotification} t={t} />
    </>
  );
};

export default TelegramChatsContainer;
